import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = process.env.REACT_APP_API_URL || ''

// Requests
const requests = {
  post: (url: string, body: any) => {
    return axios.post(API_URL + url, body);
  }
};

const ReminderAPI = {
  createReminders: (ids: number) => {
    return requests.post(RoutesAPI.reminder(ids));
  },
}

export default ReminderAPI;



// WEBPACK FOOTER //
// ./src/api/ReminderApi.js